import update from 'immutability-helper';
import cloneDeep from 'lodash/cloneDeep';

import * as dimContainerTypes from '@store/dimensionContainer/types';
import * as filterContainerTypes from '@store/filterContainer/types';
import { initialState as commonState } from '@store/common/reducer';
import * as types from './types';

const initialState = [];

const DRILLDOWN_LIMIT = 40;

const reducerMap = Object.create(null);

reducerMap[filterContainerTypes.RESET_DRILL_DOWN] = state => update(state, {
  $set: [],
});

reducerMap[types.DRILL_UP] = (state, action) => {
  const { breadcrumbIndex } = action;
  let drilldown = cloneDeep(state);
  drilldown = drilldown.slice(0, breadcrumbIndex + 1);
  return update(state, {
    $set: drilldown,
  });
};

reducerMap[dimContainerTypes.PUSH_DRILLDOWN_FILTER] = (state, action) => {
  const filter = {
    name: action.name,
    rule: action.rule,
    presetFid: action.presetFid || null,
  };
  const drilldown = cloneDeep(state);
  if (drilldown.length === 0) {
    drilldown.push(commonState.appliedFilters[0]);
  }
  if (!drilldown.map(f => f.name)
    .includes(action.name)) {
    drilldown.push(filter);
  }
  if (drilldown.length > DRILLDOWN_LIMIT) {
    drilldown.splice(0, 1);
  }
  return update(state, {
    $set: drilldown,
  });
};

reducerMap[dimContainerTypes.PUSH_MULTI_DRILLDOWN_FILTER] = (state, action) => {
  const filters = action.rules.map(i => ({
    name: i.name,
    rule: i.rule,
    presetFid: i.presetFid || null,
  }));
  const drilldown = cloneDeep(state);
  if (drilldown.length === 0) {
    drilldown.push(commonState.appliedFilters[0]);
  }
  filters.forEach((filter) => {
    if (!drilldown.map(f => f.name)
      .includes(filter.name)) {
      drilldown.push(filter);
    }
    if (drilldown.length > DRILLDOWN_LIMIT) {
      drilldown.splice(0, 1);
    }
  });
  return update(state, {
    $set: drilldown,
  });
};

reducerMap[types.RESET_DRILL_DOWN] = (state, action) => {
  const { drilldownData } = action;
  return update(state, {
    $set: drilldownData,
  });
};

const reducer = (state = initialState, action) => (
  reducerMap[action.type]
    ? reducerMap[action.type](state, action)
    : state
);

export default reducer;
